import { OnlineSales } from 'gw-edge-client';
import { opcInfoAtom } from '../atoms/opcInfoAtom';
import type { EffectiveDateRuleDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/opc';
import { selector } from 'recoil';
import { jobInfoAtom } from '../atoms/jobInfoAtom';
import { isLoggedOnSelector } from './isLoggedOnSelector';
import { businessFlowSelector } from './getBusinessFlowSelector';

export const getEffectiveDateRuleInfoSelector = selector<EffectiveDateRuleDTO>({
    key: 'getEffectiveDateRuleInfoSelector',
    get: async ({ get }) => {
        const businessFlow = get(businessFlowSelector);
        const isLoggedOn = get(isLoggedOnSelector);
        if (!isLoggedOn || businessFlow !== 'OPC')
            return {
                isRuleActive: false,
                effectiveDate: {}
            };
        const { productName, coverableId } = get(opcInfoAtom);
        const { jobNumber, sessionId } = get(jobInfoAtom);

        return await OnlineSales.getEffectiveDateRuleInfo(
            jobNumber,
            sessionId,
            productName,
            coverableId
        );
    }
});
